<div class="modal-header">
    <h4 class="modal-title pull-left">Settings</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="bsModalRef?.hide()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="wrapper-inner user_screen">
        <div class="container-fluid">
            <div class="row">

                <div class="col-md-12 userTables">
                    <div class="row justify-content-center">
                        <div class="col-md-12">
                            <form class="admin_form" [formGroup]="formData" (ngSubmit)="onSubmit()">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Min Bet:</label>
                                            <input type="text" name="min_bet" formControlName="min_bet" class="form-control">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Max Bet:</label>
                                            <input type="text" name="max_bet" formControlName="max_bet" class="form-control">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Max Profit:</label>
                                            <input type="text" name="max_profit" formControlName="max_profit" class="form-control">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Max Market Profit:</label>
                                            <input type="text" name="max_market_profit" formControlName="max_market_profit" class="form-control">
                                        </div>
                                    </div>
                                    <div class="col-md-6 checkboxui">
                                        <div class="form-check">
                                            <span style="margin-right: 5px;">Bet Lock</span>
                                            <input class="form-check-input" type="checkbox" formControlName="bet_allow" id="gridCheck">
                                            <label class="form-check-label" for="gridCheck">
                                            </label>
                                            <span>Bet Open</span>
                                        </div>
                                    </div>
                    
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <button type="submit" class="btn btnSubmit" [disabled]="formData.invalid || isLoad">Save</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>

                <app-loader class="full-overlay" *ngIf="!data || isLoad"></app-loader>
            </div>
        </div>
    </div>
</div>